import _BaseController from 'Controllers/Web/_BaseController';
import ServicemapSimpleTaiwanCountySelector from 'Vue/Web/Common/ServiceMap/ServicemapSimpleTaiwanCountySelector.vue';
import Datalayer from 'Controllers/Web/Datalayer';

global.Controller = new (class extends _BaseController {
  ServiceMapControllerVue?: Vue;

  ready() {
    super.ready();

    // datalayer
    Datalayer.push(Json.datalayer);

    this.ServiceMapControllerVue = new Vue({
      el: '.mapSearchBox',
      components: {
        ServicemapSimpleTaiwanCountySelector,
      },
    });
  }
})();
